<template>
  <div>
    <div v-if="!sortedItems.length" class="text-caption pw-muted py-2">La liquidación no tiene atenciones.</div>
    <div
      v-for="item in sortedItems"
      :key="item.invoiceId"
      class="attendance-row"
      :class="{ 'attendance-row--canceled': isCanceled(item) }"
    >
      <div class="attendance-main">
        <span class="attendance-title">{{ item.petName }} · {{ item.coverage }}</span>
        <span class="attendance-sub">{{ attendanceSubtitle(item) }}</span>
        <span v-if="isCanceled(item) && item.cancellationReason" class="attendance-sub">
          Motivo: {{ item.cancellationReason }}
        </span>
      </div>
      <div class="attendance-side">
        <span class="attendance-amount">{{ formatClp(item.pawerAmount) }}</span>
        <v-btn
          v-if="editable && !isCanceled(item)"
          x-small
          outlined
          color="error"
          class="cancel-btn"
          @click="$emit('cancel', item)"
        >
          <v-icon x-small left>mdi-delete-outline</v-icon>Anular
        </v-btn>
        <v-chip v-if="isCanceled(item)" x-small color="error" outlined>Anulada</v-chip>
        <v-btn
          v-if="editable && item.restorable"
          x-small
          outlined
          color="primary"
          class="cancel-btn"
          @click="$emit('restore', item)"
        >
          <v-icon x-small left>mdi-restore</v-icon>Restaurar
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { attendanceSubtitle, formatClp, sortAttendanceItems } from '@/utils/clinic-settlements.utils';

// "Desglose de atenciones" del detalle: las anuladas van tachadas y al final.
// Emite `cancel` o `restore` con la atención elegida; los diálogos los abre el padre.
// "Restaurar" solo aparece si el backend marca la anulación como reversible.
export default {
  name: 'SettlementAttendanceList',
  props: {
    items: { type: Array, default: () => [] },
    editable: { type: Boolean, default: false }
  },
  computed: {
    sortedItems() {
      return sortAttendanceItems(this.items);
    }
  },
  methods: {
    formatClp,
    attendanceSubtitle,
    isCanceled(item) {
      return item.status === 'canceled';
    }
  }
};
</script>

<style scoped>
.attendance-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid var(--pw-divider);
  font-size: 13px;
}
.attendance-main {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.attendance-title {
  font-weight: 600;
  color: var(--pw-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.attendance-sub {
  color: var(--pw-text-muted);
  word-break: break-all;
}
.attendance-side {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.attendance-amount {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}
.attendance-row--canceled .attendance-title,
.attendance-row--canceled .attendance-amount {
  color: var(--pw-text-faint);
  text-decoration: line-through;
}
.pw-muted {
  color: var(--pw-text-muted);
}
</style>
